<div class="container">
  @if (isAutofilling) {
    <div class="title">Remplissage Automatique<br /><br /></div>
  } @else {
    <div class="title">Exporter<br /><br /></div>
  }

  <ng-container *ngIf="formGroup as fg; else loading">
    <form class="body" fxLayout="column" fxLayoutAlign="start stretch">
      <div fxLayout="column" fxLayoutAlign="start start">
        <div class="select-label-pos no-mg-t">Dates de début et de fin</div>
        <app-range-date-picker
          [showArrows]="false"
          (SelectedDates)="dateChange($event)"
          [sideOpening]="'right'"
          [startDay]="fg.get('startDate')?.value"
          [endDay]="fg.get('endDate')?.value"
          [hasWeekRanges]="true"
        ></app-range-date-picker>
      </div>

      <p class="error" *ngIf="fg.hasError('invalidRange')">
        La date de fin doit être après (ou égale à) la date de début.
      </p>
      @if (!isRecoveryRoomExport && !isAutofilling) {
        <p class="notice">L'export contiendra les dernières informations sauvegardées.</p>
      }

      <br />
    </form>

    <div class="buttons" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
      <app-button text="Annuler" btnType="text" (click)="close()"></app-button>
      <app-button [text]="isAutofilling ? 'Remplir' : 'Exporter'" [disabled]="fg.invalid" (click)="export()">
      </app-button>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="spinnerContainer" fxLayoutAlign="center center">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>
</div>
